import {
  ACTION_PAGE,
  ACTION_SET_AUTHENTICATION,
  ACTION_TEAM_VISUAL_IDENTITY,
  ACTION_LOGIN,
  ACTION_TEAM_CONFIG,
  ACTION_USER_PERMISSIONS,
  ACTION_USER_PROFILE,
  ACTION_REPLY,
  ACTION_CHANNELS_SET,
  ACTION_CHANNELS_UPDATE,
  ACTION_CHANNELS_ADD,
  ACTION_CHANNELS_REMOVE,
  ACTION_CHANNELS_CONNECTION_STATE,
  ACTION_CHANNELS_CURRENT,
} from './actionTypes'

export const changePage = value => ({
  type: ACTION_PAGE,
  page: value
})

export const setToken = value => ({
  type: ACTION_LOGIN,
  token: value 
})

export const setAuthentication = () =>({
  type: ACTION_SET_AUTHENTICATION
})

export const setTeamVisualIdentity = value => ({
  type: ACTION_TEAM_VISUAL_IDENTITY,
  visualIdentity: value,
})

export const setTeamConfig = value => ({
  type: ACTION_TEAM_CONFIG,
  config: value
})

export const setUserPermissions = value => ({
  type: ACTION_USER_PERMISSIONS,
  permissions: value
})

export const setUserProfile = value => ({
  type: ACTION_USER_PROFILE,
  profile: value
})
export const setReplyState = ({ isReplying,
  commentId,
  receiverName,
  replyCounts,
  repliesAddedCounts }) => ({
    type: ACTION_REPLY,
    isReplying,
    commentId,
    receiverName,
    replyCounts,
    repliesAddedCounts,
  })

export const setChannels = (channels) => ({
  type: ACTION_CHANNELS_SET,
  channels,
})

export const updateChannel = (channel) => ({
  type: ACTION_CHANNELS_UPDATE,
  channel,
})

export const addChannel = (channel) => ({
  type: ACTION_CHANNELS_ADD,
  channel,
})

export const removeChannel = (channelId) => ({
  type: ACTION_CHANNELS_REMOVE,
  channelId,
})

export const setChannelConnectionState = (payload) => ({
  type: ACTION_CHANNELS_CONNECTION_STATE,
  ...payload,
})

export const setCurrentChannelId = (channelId) => ({
  type: ACTION_CHANNELS_CURRENT,
  channelId,
})
